export const recognized_officers = `
1st Vice Chairman
2nd Vice Chairman
Acting Chairlady
Acting Chairman
Acting Secretaries
Acting Secretary
Acting Vice Chairman
Arrangements
Arranging
Arranging Committee
Arranging Committee/Secretary
Assistant Chairperson
Assistant Secretaries
Assistant Secretary
Assistant Secretary/Treasurer
Chair
Chairladies
Chairlady
Chairman
Chairman Elect
Chairman and Secretary
Chairman and Treasurer
Chairman/Arranging Committee/Secretary
Chairman/Secretary
Chairmen
Chairperson
Chairperson and Secretary
Chairperson/Arranging
Chairpersons
Chairwoman
Chaplain
Chaplains
Co-Chairlady
Co-Chairman
Co-Chairmen
Co-Chairperson
Co-Chairperson and Secretary
Co-Secretaries
Co-Vice Chairmen
Co-Vice Chairpersons
Corresponding Secretary
Finance
Finance Committee
First Vice Chairman
Honorary Chairman
Honorary Co-Chairman
Honorary Lifetime Chairmen
Honorary Vice Chairman
Honorary Vice Chairperson
Interim Secretary
Local Arrangements
Locating Committee
President
Recording Secretary
Rising Chairman
Rising Chairperson
SHMHA President and Camp Director
Second Vice Chairman
Secretarial Committee
Secretaries
Secretaries and Arranging Committee
Secretary
Secretary and Treasurer
Secretary pro-tem
Secretary/Arranging
Secretary/Arranging Committee
Secretary/Treasurer
Senior Honorary Chairman
Treasurer
Vice Chair
Vice Chairladies
Vice Chairlady
Vice Chairlady/Secretary
Vice Chairman
Vice Chairman and Arranging
Vice Chairman and Arranging Committee
Vice Chairman and Secretary
Vice Chairman and Treasurer
Vice Chairman/Arranging Committee
Vice Chairman/Secretary
Vice Chairmen
Vice Chairperson
Vice Chairperson and Secretary
Vice Chairpersons
Vice Chairs
Vice Chairwoman
Vice President
Vice-Chairlady
Vice-Chairman
Vice-Chairman/Secretary
Vice-Chairperson
Vice-President
`
  .split(/ *\n+ */)
  .filter(i => {
    return i.match(/\w/);
  });



// WEBPACK FOOTER //
// ./src/recognized_officers.js